var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuReportGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#86888C;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\xE1bana-de-iconos-Copy",
    transform: "translate(-432.000000, -1294.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_filecabinet",
    className: "st0",
    d: "M911,1761.9c0,6.1-4.9,11.1-11,11.1H464.1c-6,0-11-5-11-11.1v-185.3 c0-5.9,5-10.9,11-10.9h150v12.1c0,36.1,29.4,65.5,65.5,65.5h5c36.1,0,65.5-29.4,65.5-65.5v-12.1h150c5.2,0,9.6,3.6,10.7,8.2 l0.1,0.9c0.1,0.6,0.2,1.1,0.2,1.8L911,1761.9L911,1761.9z M494.7,1326c0-6,4.9-11,10.9-11l352.7,0.4c6.4,0,12,5.7,13.4,13.5 l34.4,217c-2.1-0.4-4.1-1.1-6.3-1.1H739.6c-5.8,0-10.4,4.6-10.4,10.4v22.5c0,24.6-20,44.6-44.7,44.6h-5c-24.7,0-44.7-20-44.7-44.6 v-22.5c0-5.8-4.7-10.4-10.4-10.4H464.1c-2.1,0-4.1,0.2-6.1,0.6L494.7,1326z M931.6,1574.7c0-0.4,0.1-0.8,0.1-1.2l-0.4-2.9 c0-0.1,0-0.1,0-0.2v-0.1l-38.8-244.8c-3.3-18.2-17.3-30.9-33.9-30.9l-352.7-0.4c-17.5,0-31.8,14.3-31.6,30.1l-41.6,247.4 c-0.1,0.6,0.1,1.3,0.1,1.9c-0.1,1-0.3,2-0.3,3v185.3c0,17.6,14.3,31.9,31.8,31.9h436c17.5,0,31.8-14.3,31.8-31.9v-185.3 C931.9,1576.1,931.7,1575.3,931.6,1574.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuReportGray);
export default __webpack_public_path__ + "static/media/ic-menu-report-gray.85c6aba5e4be772575b84ed9c54b4f57.svg";
export { ForwardRef as ReactComponent };